import { useEffect } from 'react'

const STABLE_BROWSER_TITLE = 'Gecko Cantilever'

/**
 * Keeps the Chrome/browser tab on a stable title while workspace tabs are
 * mounted. Destination pages (e.g. Dossiers) still set document.title on mount;
 * this effect runs afterward (parent effects run after children) and again on
 * route/tab changes so those writes do not stick after the workspace tab closes.
 */
export function useSyncBrowserDocumentTitle(
  locationHref: string,
  activeTabId: string | undefined
): void {
  useEffect(() => {
    document.title = STABLE_BROWSER_TITLE
  }, [locationHref, activeTabId])
}
